export default __webpack_public_path__ + "static/cham-25e07d64f9759542498c6ffeb76cfac0.jpg";